/* Nutrise Product Showcase v1.21 */
(() => {
function initProductCarousel(root) {
      if (!root || root.dataset.carouselInitialized === 'true') return;

      const track = root.querySelector('[data-carousel-track]');
      const cards = Array.from(root.querySelectorAll('[data-carousel-card]'));
      const previousButton = root.querySelector('[data-carousel-prev]');
      const nextButton = root.querySelector('[data-carousel-next]');
      const currentCounter = root.querySelector('[data-carousel-current]');
      const totalCounter = root.querySelector('[data-carousel-total]');
      const progressBar = root.querySelector('[data-carousel-progress]');
      const productForms = Array.from(
        root.querySelectorAll('[data-product-form]')
      );

      if (!track || cards.length === 0) return;

      root.dataset.carouselInitialized = 'true';

      let activeIndex = 0;
      let scrollFrame = null;
      let resizeFrame = null;
      let isPointerDown = false;
      let pointerStartX = 0;
      let scrollStartLeft = 0;
      let dragDistance = 0;

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      function formatNumber(value) {
        return String(value).padStart(2, '0');
      }

      function isInteractiveElement(target) {
        return Boolean(
          target.closest(
            'a[href], button, form, input, select, textarea, label, [role="button"], [data-product-form], [data-add-to-cart]'
          )
        );
      }

      function getTrackCenter() {
        const rect = track.getBoundingClientRect();
        return rect.left + rect.width / 2;
      }

      function getCardCenter(card) {
        const rect = card.getBoundingClientRect();
        return rect.left + rect.width / 2;
      }

      function findClosestCardIndex() {
        const trackCenter = getTrackCenter();
        let closestIndex = 0;
        let closestDistance = Infinity;

        cards.forEach((card, index) => {
          const distance = Math.abs(
            getCardCenter(card) - trackCenter
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function updateCardStates(index) {
        activeIndex = Math.max(
          0,
          Math.min(index, cards.length - 1)
        );

        cards.forEach((card, cardIndex) => {
          const distance = Math.abs(cardIndex - activeIndex);

          card.classList.toggle('is-active', distance === 0);
          card.classList.toggle('is-near', distance === 1);
          card.classList.toggle('is-far', distance > 1);

          if (distance === 0) {
            card.setAttribute('aria-current', 'true');
          } else {
            card.removeAttribute('aria-current');
          }
        });

        if (currentCounter) {
          currentCounter.textContent = formatNumber(
            activeIndex + 1
          );
        }

        if (totalCounter) {
          totalCounter.textContent = formatNumber(
            cards.length
          );
        }

        if (progressBar) {
          const progress =
            ((activeIndex + 1) / cards.length) * 100;

          progressBar.style.width = `${progress}%`;
        }

        if (previousButton) {
          previousButton.disabled = activeIndex === 0;
        }

        if (nextButton) {
          nextButton.disabled =
            activeIndex === cards.length - 1;
        }
      }

      function centerCard(index, behavior = 'smooth') {
        const targetCard = cards[index];

        if (!targetCard) return;

        const targetLeft =
          targetCard.offsetLeft -
          (track.clientWidth - targetCard.offsetWidth) / 2;

        track.scrollTo({
          left: targetLeft,
          behavior: reducedMotion ? 'auto' : behavior
        });

        updateCardStates(index);
      }

      function handleScroll() {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(() => {
          const closestIndex = findClosestCardIndex();

          if (closestIndex !== activeIndex) {
            updateCardStates(closestIndex);
          }
        });
      }

      function handleResize() {
        if (resizeFrame) {
          window.cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = window.requestAnimationFrame(() => {
          centerCard(activeIndex, 'auto');
        });
      }

      function handlePointerDown(event) {
        if (isInteractiveElement(event.target)) {
          dragDistance = 0;
          return;
        }

        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }

        isPointerDown = true;
        pointerStartX = event.clientX;
        scrollStartLeft = track.scrollLeft;
        dragDistance = 0;

        track.classList.add('is-dragging');

        if (track.setPointerCapture) {
          track.setPointerCapture(event.pointerId);
        }
      }

      function handlePointerMove(event) {
        if (!isPointerDown) return;

        const movement =
          event.clientX - pointerStartX;

        dragDistance = Math.max(
          dragDistance,
          Math.abs(movement)
        );

        track.scrollLeft =
          scrollStartLeft - movement;
      }

      function handlePointerUp(event) {
        if (!isPointerDown) return;

        isPointerDown = false;
        track.classList.remove('is-dragging');

        if (
          track.hasPointerCapture &&
          track.hasPointerCapture(event.pointerId)
        ) {
          track.releasePointerCapture(event.pointerId);
        }

        const closestIndex =
          findClosestCardIndex();

        centerCard(closestIndex);
      }

      function handleClickCapture(event) {
        if (isInteractiveElement(event.target)) {
          dragDistance = 0;
          return;
        }

        if (dragDistance > 8) {
          event.preventDefault();
          event.stopPropagation();
        }

        dragDistance = 0;
      }

      async function handleProductSubmit(event, form) {
        event.preventDefault();
        event.stopPropagation();

        const submitButton = form.querySelector('[data-add-to-cart]');
        const submitText = form.querySelector('[data-add-to-cart-text]');
        const status = form.querySelector('[data-add-to-cart-status]');

        if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

        const originalLabel = submitText?.textContent || '';
        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData(form);

        if (cartDrawer?.getSectionsToRender) {
          formData.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',')
          );
          formData.append('sections_url', `${window.location.pathname}${window.location.search}`);
          cartDrawer.setActiveElement?.(submitButton);
        }

        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
        if (submitText) submitText.textContent = 'Wird hinzugefügt …';
        if (status) status.textContent = '';

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');
          }

          if (cartDrawer?.renderContents && result.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(result);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:update'));
        } catch (error) {
          if (status) status.textContent = error.message || 'Bitte versuche es erneut.';
        } finally {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
          if (submitText) submitText.textContent = originalLabel;
        }
      }

      previousButton?.addEventListener('click', () => {
        centerCard(activeIndex - 1);
      });

      nextButton?.addEventListener('click', () => {
        centerCard(activeIndex + 1);
      });

      track.addEventListener(
        'scroll',
        handleScroll,
        { passive: true }
      );

      track.addEventListener(
        'pointerdown',
        handlePointerDown
      );

      track.addEventListener(
        'pointermove',
        handlePointerMove
      );

      track.addEventListener(
        'pointerup',
        handlePointerUp
      );

      track.addEventListener(
        'pointercancel',
        handlePointerUp
      );

      track.addEventListener(
        'click',
        handleClickCapture,
        true
      );

      window.addEventListener(
        'resize',
        handleResize
      );

      cards.forEach((card, index) => {
        card.addEventListener('click', (event) => {
          if (isInteractiveElement(event.target)) {
            return;
          }

          if (
            index !== activeIndex &&
            dragDistance <= 8
          ) {
            event.preventDefault();
            centerCard(index);
          }
        });
      });

      productForms.forEach((form) => {
        form.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
          dragDistance = 0;
        });

        form.addEventListener('click', (event) => {
          event.stopPropagation();
          dragDistance = 0;
        });

        form.addEventListener('submit', (event) => {
          handleProductSubmit(event, form);
        });
      });

      window.requestAnimationFrame(() => {
        centerCard(0, 'auto');
      });
    }

    function initSection(scope = document) {
      const roots = [];
      if (scope.matches?.('[data-product-carousel]')) roots.push(scope);
      scope.querySelectorAll?.('[data-product-carousel]').forEach((root) => roots.push(root));
      roots.forEach(initProductCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initSection,
        { once: true }
      );
    } else {
      initSection();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initSection(event.target);
      }
    );
  })();
